import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=4fbd9e56"
import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=4fbd9e56&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports